<ul>
  <li *ngFor="let item of timeArray; let i = index" (click)="clickHandler(item)" [class.active]="value === item">
    <span>{{ item }}</span>
  </li>
</ul>
